import { render } from "./Approve-Reject.vue?vue&type=template&id=25b60f68&scoped=true"
import script from "./Approve-Reject.vue?vue&type=script&lang=js"
export * from "./Approve-Reject.vue?vue&type=script&lang=js"

import "./Approve-Reject.vue?vue&type=style&index=0&id=25b60f68&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/takayama_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b60f68"]])

export default __exports__